import { render, staticRenderFns } from "./Imofalform2Form.vue?vue&type=template&id=e1e0d0f6"
import script from "./Imofalform2Form.vue?vue&type=script&lang=js"
export * from "./Imofalform2Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports